export var getStatusId = function getStatusId(status) {
  var statusId = void 0;
  switch (status.toLowerCase()) {
    case 'initiated':
      statusId = 'label.status.initiated';
      break;
    case 'completed':
      statusId = 'label.status.completed';
      break;
    case 'canceled':
      statusId = 'label.status.canceled';
      break;
    case 'rollbacked':
      statusId = 'label.status.rollbacked';
      break;
    default:
      statusId = status;
  }
  return statusId;
};

export var getTypeId = function getTypeId(type) {
  var typeId = void 0;
  switch (type.toLowerCase()) {
    case 'deposit':
      typeId = 'history.type.deposit';
      break;
    case 'withdraw':
      typeId = 'history.type.withdraw';
      break;
    default:
      typeId = type;
  }
  return typeId;
};